export default __webpack_public_path__ + "static/media/template_1on1.c524adaa.png";